export default __webpack_public_path__ + "static/media/BenefirsIcon2.63e39bb2.svg";